export default __webpack_public_path__ + "static/media/IF_MySalesStyle_StrengthArea_02.137a9629.jpg";